import { Component, OnInit, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { moveItemInArray, CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ManikEntityFE } from 'src/app/manik-library/ManikEntityFE';
import { IEditOptions } from '../site-edit.component';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';
@Component({
  selector: 'app-microsite-menu',
  templateUrl: './microsite-menu.component.html'
})
export class MicrositeMenuComponent extends ManikEntityFE implements OnInit {
  MenuForm: FormGroup;
  ShowMenu: boolean = true;
  ShowBackground: boolean = false;
  public DisplayOrderList: IMenuDisplayOrder[] = [];
  public InUseMenuList: IMenuItems[] = [];
  public NotInUseMenuList: IMenuItems[] = [];
  IsEdit: boolean = false;
  @Input() public EditOption: IEditOptions;
  IsUpdatedMenuOrder: boolean = false;
  IsPageLoaded: boolean = false;
  public DesignerEffects: { DataValue: string; DataText: string };

  constructor(private cdRef: ChangeDetectorRef,private formBuilder: FormBuilder, private _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
    this.MenuForm = this.formBuilder.group({
      MicrositeSectionID: '',
      MenuItemText: ['', Validators.required],
      SectionIdentifier: [''],
      TagToMenu: [''],
      DisplayOrder: ['', Validators.required],
      AllowReOrder: '',
      SelectedEffectID: [0, Validators.required]
    });
  }

  populateControls(): void {
    this.IsUpdatedMenuOrder = false;
    this.IsEdit = false;
    // alert("menu2")
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareLoadHeaders2(this.EditOption.BusinessHandle, "MICROSITE.MENU", "BIZ", this.EditOption.PortalContext))
      .subscribe(data => {
        // alert("menu3")
        this.IsPageLoaded = true;
        this.DisplayOrderList = data.ManikJSon[0].JSon0;
        this.InUseMenuList = data.ManikJSon[0].JSon1[0].MicrositeSectionID ? data.ManikJSon[0].JSon1 : [];
        this.NotInUseMenuList = data.ManikJSon[0].JSon2[0].MicrositeSectionID ? data.ManikJSon[0].JSon2 : [];
        // this.cdRef.detectChanges();
      },
        error => {
          this.showNotification('bottom', 'right', 'danger', 'Server error: Please try again');
        });
  }

  ngOnInit() {
    if (this.EditOption.PortalContext) {
      sessionStorage.setItem('PortalIdentifier', this.EditOption.PortalContext);
      sessionStorage.setItem('PortalDS', this.EditOption.PortalDS);
    }
    this.populateControls();
  }

  ShowWorkspace(selectedMenu: any) {
    switch (selectedMenu) {
      case 'Menu':
        this.ShowMenu = true;
        this.ShowBackground = false;
        break;
      case 'Background':
        this.ShowMenu = false;
        this.ShowBackground = true;
        break;
    }
  }

  SubmitDataToDatabase() {
    if (this.IsEdit) {
      if (this.MenuForm.invalid) {
        return;
      }
      let body = this.MenuForm.value;
      body["TagToMenu"] = body.TagToMenu ? "Y" : "N";
      body["BusinessHandle"] = this.EditOption.BusinessHandle;
      let FormSubmittedDataTwo = JSON.stringify({ 'items': [body] });
      this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FormSubmittedDataTwo,
        this.prepareManageHeaders2("SMART_MANAGE", "MICROSITE.MENU", "BIZ", this.EditOption.PortalContext))
        .subscribe(async data => {
          let id = data.ManikJSon[0].JSon0[0];
          if (id != null) {
            this.showNotification('bottom', 'right', 'success', 'Menu item update: Success');
            await this.populateControls();
          }
          else {
            this.showNotification('bottom', 'right', 'danger', 'Menu item update: Failure');
          }
        });
    }
    if (this.IsUpdatedMenuOrder) {
      this.SortRows();
    }

  }

  editRow(item: any) {
    if (item.AllowReOrder == 'N') {
      return;
    }
    this.IsEdit = true;
    item.TagToMenu = item.TagToMenu === "Y" ? true : false;
    this.MenuForm.patchValue(item);
    this.BindEffects(item.MicrositeSectionID);
  }

  BindEffects(MicrositeSectionID: number): void {
    this.updateFilterParams(MicrositeSectionID);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("ULTRA.QUICK", "MICROSITE.DESIGNER.EFFECTS", "BIZ", this.EditOption.PortalContext))
      .subscribe(data => {
        this.DesignerEffects = data.ManikJSon[0].JSon0;
      });
  }

  SortRows() {
    let body = [];
    for (let i = 0; i < this.InUseMenuList.length; i++) {
      if (this.InUseMenuList[i].MicrositeSectionID)
        body.push({
          "MicrositeSectionID": this.InUseMenuList[i].MicrositeSectionID,
          "SectionIdentifier": this.InUseMenuList[i].SectionIdentifier,
          "DisplayOrder": i + 1,
          "BusinessHandle": this.EditOption.BusinessHandle,
          "MenuItemText": this.InUseMenuList[i].MenuItemText,
          "InUse": "Y",
          "SelectedEffectID": this.InUseMenuList[i].SelectedEffectID
        });
    }
    for (let i = 0; i < this.NotInUseMenuList.length; i++) {
      if (this.NotInUseMenuList[i].MicrositeSectionID)
        body.push({
          "MicrositeSectionID": this.NotInUseMenuList[i].MicrositeSectionID,
          "SectionIdentifier": this.NotInUseMenuList[i].SectionIdentifier,
          "DisplayOrder": i + 1,
          "BusinessHandle": this.EditOption.BusinessHandle,
          "MenuItemText": this.NotInUseMenuList[i].MenuItemText,
          "InUse": "N",
          "SelectedEffectID": this.NotInUseMenuList[i].SelectedEffectID
        });
    }

    let FormSubmittedDataTwo = JSON.stringify({ 'items': body });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FormSubmittedDataTwo,
      this.prepareManageHeaders2("SMART_MANAGE", "MICROSITE.MENU", "BIZ", this.EditOption.PortalContext))
      .subscribe(async data => {
        let id = data.ManikJSon[0].JSon0[0];
        if (id != null) {
          this.showNotification('bottom', 'right', 'success', 'menu order updated');
          await this.populateControls();
        }
        else {
          this.showNotification('bottom', 'right', 'danger', 'Unable to update menu order');
        }
      },
        error => {
          let err = error.error;
        });
  }

  drop(event: CdkDragDrop<IMenuItems[]>) {
    if (event.item.data.AllowReOrder === "N") {
      return;
    }
    this.IsUpdatedMenuOrder = true;
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  get frmMenu() {
    return this.MenuForm.controls;
  }
}

export interface IMenuItems {
  AllowReOrder: string;
  DisplayOrder: number;
  MenuItemText: string;
  MicrositeSectionID: number;
  SectionIdentifier: string;
  SelectedEffectID: number;
}

export interface IMenuDisplayOrder {
  DataValue: string;
  Column1: string;
}

